/**
 * Layout component for login/auth pages
 * Provides a clean, centered layout without sidebar or navigation
 * Uses the same background as private pages (gradient + image)
 */
export default function LoginLayout({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-6 login-layout-bg">
      {children}
    </div>
  );
}

